import { Chip, ChipProps, paletteColors, SxProps } from '@evaneos/b2b-ui';

import { useIntl } from 'react-intl';

import { Heat } from '../../../resources/dossier/types';

import { heatMap } from './heat-utilities';

type HeatChipProps = {
    heatLevel: Heat;
    isSelected?: boolean;
    showLabel?: boolean;
    isRevamped?: boolean;
    sx?: SxProps;
} & Pick<ChipProps, 'component' | 'onClick'>;

export const HeatChip = ({
    heatLevel,
    isSelected,
    showLabel,
    isRevamped,
    sx,
    ...chipProps
}: HeatChipProps) => {
    const { formatMessage } = useIntl();
    if (heatLevel === Heat.NONE) {
        return null;
    }
    const { labelId, accentColor, icon } = heatMap[heatLevel];
    const label = formatMessage({ id: labelId });

    const backgroundActiveColor = isRevamped ? accentColor[200] : accentColor[600];
    const backgroundInactiveColor = isRevamped
        ? paletteColors.neutral[100]
        : paletteColors.yellow[200];
    const textActiveColor = isRevamped ? accentColor[900] : paletteColors.neutral[0];
    const textInactiveColor = 'text.primary';
    return (
        <Chip
            data-testid={`heat-chip-${labelId}`}
            aria-label={label}
            icon={isRevamped ? undefined : icon}
            {...chipProps}
            label={showLabel ? label : ''}
            size="small"
            sx={{
                transition: 'all 0.3s',
                border: '1px solid',
                borderColor: isSelected ? backgroundActiveColor : backgroundInactiveColor,
                backgroundColor: isSelected ? backgroundActiveColor : backgroundInactiveColor,
                fontWeight: isRevamped ? 400 : 600,
                px: 0.5,
                color: isSelected ? textActiveColor : textInactiveColor,
                borderRadius: '4px',
                '.MuiChip-label': {
                    paddingLeft: 0,
                },
                '.MuiSvgIcon-root': {
                    fill: isSelected ? paletteColors.neutral[0] : backgroundActiveColor,
                },
                ...sx,
            }}
        />
    );
};
